<template>
  <div class="py-4 bg-light_gray border-t border-b border-section_border">
    <div class="px-4">
      <template v-if="token">
        <a @click="confirmSave" class="button-primary block">
          {{ $t('tour_save_label') }}
        </a>
      </template>
      <template v-else>
        <p>{{$t('tour_login_message')}}</p>
      </template>
    </div>
    <div class="mt-4 px-4">
      <a class="button-secondary block button-icon icon-left" @click="back">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_back_to_plan_top_label') }}</span>
      </a>
    </div>
    <div class="mt-4 px-4">
      <a :href="tohoku_maas_url()" class="button-secondary block button-icon icon-left">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_tohoku_maas_link') }}</span>
      </a>
    </div>
    <plan-save-modal
      v-show="modalShow"
      :defaultTitle="title"
      :closeModal="() => closeModal()"
      :callback="() => save()"
      @updateTitle="title => updateTitle(title)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlanSaveModal from '../molecules/PlanSaveModal'
import Constants from '../../constants'

export default {
  components: {
    PlanSaveModal
  },
  props: {
    planId: {
      type: String,
      default: function () {
        return undefined
      }
    }
  },
  data () {
    return {
      modalShow: false
    }
  },
  methods: {
    confirmSave: function () {
      this.modalShow = true
    },
    save: function () {
      // GoogleAnalytics
      this.$gtag.event("プラン保存", {
        plan_id: this.planId
      });
      
      this.modalShow = false
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('plans/save', this.planId,)
        .then((id) => {
          this.$store.dispatch('loading/endLoading')
          this.$router.push({ name: 'complete', params: { planId: id } })
        })
        .catch(() => {
          this.$store.dispatch('loading/resetLoading')
          this.$alert({ message: this.$t('tour_system_error_message') })
        })
    },
    back: function () {
      this.$router.push({ path: '/plans' })
    },
    closeModal: function () {
      this.modalShow = false
    },
    updateTitle: function (title) {
      this.$store.dispatch('plans/updateTitle', title)
    },
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken'
    }),
    title: function () {
      return this.$store.getters['plans/getTitle']
    }
  }
}
</script>
